import { Box, Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { RanaForm, SendIcon } from "@nens/ranalib";

import { UsePublicationCommentReturn } from "../hooks/use-comment";

const PADDING = 2;

type PublicationNewCommentFormProps = Pick<
  UsePublicationCommentReturn,
  "createCommentThread" | "creatingCommentAt"
>;

export function PublicationNewCommentForm({
  createCommentThread,
  creatingCommentAt,
}: PublicationNewCommentFormProps) {
  const intl = useIntl();

  if (!creatingCommentAt) return null;

  return (
    <Box borderRadius="base" minW="2xs" maxW="sm">
      <RanaForm
        initialValues={{ comment: "" }}
        emptyOnSubmit
        doSubmit={({ comment }) => {
          if (!comment) return;
          createCommentThread({ location: creatingCommentAt, comment: comment + "" });
        }}
      >
        <Flex p={PADDING} pb={0} gap={PADDING}>
          <RanaForm.Input
            explanation={intl.formatMessage({
              id: "add_comment",
              defaultMessage: "Add comment",
            })}
            submitOnEnter
            autoFocus
            field="comment"
          />
          <RanaForm.Errors />
          <RanaForm.SubmitButton w="button">
            <SendIcon />
          </RanaForm.SubmitButton>
        </Flex>
      </RanaForm>
    </Box>
  );
}
